import { useEffect, useState } from "react";
import { api, imgSrc } from "@/lib/api";
import { useT } from "@/lib/i18n";
import { useCurrency } from "@/lib/currency";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";

export default function Experiences() {
    const { t, lang } = useT();
    const { format: formatMoney } = useCurrency();
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/experiences").then((r) => setItems(r.data)).finally(() => setLoading(false));
    }, []);

    const localised = (e) => {
        // Use the translation map; fall back to original
        const tr = t(`experienceContent.${e.name}`);
        if (lang === "es" && tr && typeof tr === "object") {
            return { ...e, category: tr.category || e.category, description: tr.description || e.description };
        }
        return e;
    };

    return (
        <div data-testid="experiences-page" className="bg-bone min-h-screen">
            <Navbar />
            <section className="pt-32 lg:pt-40 pb-16 px-6 lg:px-12">
                <div className="max-w-[1500px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-8">
                    <div className="md:col-span-7">
                        <div className="eyebrow mb-4">{t("experiencesPage.eyebrow")}</div>
                        <h1 className="font-chiller text-5xl lg:text-7xl leading-[1.02] tracking-tight">
                            <span className="text-terracotta">Let's get</span> <span className="text-gold">together<br />and</span> <span className="text-forest">feel alright</span>
                        </h1>
                    </div>
                    <div className="md:col-span-4 md:col-start-9 self-end">
                        <p className="text-base text-muted2 leading-relaxed">
                            {t("experiencesPage.sub")} 
                        </p>
                    </div>
                </div>
            </section>

            <section className="px-6 lg:px-12 pb-24">
                <div className="max-w-[1500px] mx-auto">
                    {loading ? (
                        <div className="font-serif text-2xl text-espresso">{t("common.loading")}</div>
                    ) : (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 lg:gap-16">
                            {items.map((raw, i) => {
                                const e = localised(raw);
                                return (
                                    <article key={e.id} className="group" data-testid={`experience-${i}`}>
                                        <div className="aspect-[4/3] overflow-hidden bg-bone2 mb-6">
                                            <img src={imgSrc(e.image)} alt={e.name} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" />
                                        </div>
                                        <div className="flex items-center justify-between text-xs uppercase tracking-widest2 text-espresso mb-3">
                                            <span>{e.category} · {e.duration}</span>
                                            <span>{formatMoney(e.price)}</span>
                                        </div>
                                        <h2 className="font-chiller text-3xl lg:text-4xl mb-3 leading-tight">{e.name}</h2>
                                        <p className="text-base text-muted2 leading-relaxed">{e.description}</p>
                                    </article>
                                );
                            })}
                        </div>
                    )}
                </div>
            </section>
            <Footer />
        </div>
    );
}
